import MONSTRO_10 from "url:../sprites/raposolicial.png";
import SOM_8 from "url:../sfx/pxiiuu.m4a";

export default {
  attack: 3,
  life: 10,
  speed: 4,
  agility: 7,
  weapon: 4,
  armor: 2,
  image: MONSTRO_10,
  sound: SOM_8,
};
